

import { granjaApi } from '../../api';




export const listadoCiudades = async(region) => {
    try {
        const { data } = await granjaApi.get(`/ciudades/region/${region}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const listadoRegiones = async() => {
    try {
        const { data } = await granjaApi.get(`/ciudades/regiones`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}
